import { CssBaseline } from '@mui/material';
import HistoryProvider from '@tgtg/core/router/HistoryProvider';
import { SessionProvider, SessionConsumer } from '@tgtg/core/session';
import { withErrorBoundary } from 'common/error-boundary';
import Loader from 'common/splash/Loader';
import SplashProvider from 'common/splash/SplashProvider';
import { Children, type ReactNode } from 'react';
import { Provider } from 'react-redux';
import SnackbarProvider from 'ui/Snackbar/SnackbarProvider';
import { ThemeProvider } from 'ui/theme';

import ConnectedLocaleProvider from './intl/LocaleProvider';
import store from './redux-store/store';

HistoryProvider.setDefault(history);

interface RootProps {
  children: ReactNode;
  sessionPlugins?: Array<unknown>;
}

type IsInitializedType = {
  isInitialized: boolean;
};

const Root = ({ children, sessionPlugins = [] }: RootProps) => {
  return (
    <Provider store={store}>
      <SessionProvider plugins={sessionPlugins} enableSSO>
        <SessionConsumer>
          {({ isInitialized }: IsInitializedType) => {
            if (!isInitialized) {
              return <Loader />;
            }
            return (
              <ThemeProvider>
                <CssBaseline>
                  <SplashProvider>
                    <ConnectedLocaleProvider>
                      <SnackbarProvider>{Children.only(children)} </SnackbarProvider>
                    </ConnectedLocaleProvider>
                  </SplashProvider>
                </CssBaseline>
              </ThemeProvider>
            );
          }}
        </SessionConsumer>
      </SessionProvider>
    </Provider>
  );
};

export default withErrorBoundary(Root, {
  errorTag: 'global',
});
